type TabsContentTitleParams = {
	title: string;
};

export const TabsContentTitle: React.FC<TabsContentTitleParams> = ({ title }) => {
	return <h2 className="text-muted-navy mb-12 text-4xl font-bold lg:text-5xl">{title}</h2>;
};
